// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3f-P2","unreadBadge":"styles_unreadBadge__1PI-i","modalContent":"styles_modalContent__mvneu","modal":"styles_modal__2HP-s"};